// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__18Sof","footer":"ReportModalFilter_footer__3wjwk"};